export default {
  path: "/reports",
  name: "Reports",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "",
      component: () => import("@/views/reports/Reports.vue"),
    },
    {
      path: "/listViewReports/:report_name",
      name: "List View Reports",
      component: () => import("@/views/reports/listViewReports.vue"),
    },
  ],
};
